<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <!-- <PersonSelect v-model="value" class="mr-10px"></PersonSelect> -->
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="设备设施名称"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择管控级别"
        v-model="searchData.riskLevel"
        clearable
      >
        <el-option
          v-for="item in riskLevelList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50 mb-10px"
        v-model="searchData.responsibilityUnitId"
        placeholder="请选择责任单位"
      ></department-select>
      <el-select
        v-model="searchData.evaluateMethods"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择评价方法"
        clearable
      >
        <el-option
          v-for="item in evaluateMethodsList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.controlStatus"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择管控状态"
        clearable
      >
        <el-option :key="0" label="待管控" :value="0"></el-option>
        <el-option :key="1" label="已管控" :value="1"></el-option>
        <el-option :key="2" label="已逾期" :value="2"></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :span-method="spanMethod"
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" prop="spanIndex" width="50"></el-table-column>
        <el-table-column
          width="180"
          label="辨识计划"
          prop="recognitionPlanName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="计划截止时间" prop="planTimeEnd" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{
              scope.row.planTimeEnd && dayjs(scope.row.planTimeEnd).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="管控状态"
          prop="controlStatusText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="设备设施名称"
          width="180"
          prop="equipmentFacilityName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="编号" width="120" prop="equipmentFacilityNo" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="检查项目"
          prop="checkProjectName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="检查标准"
          prop="checkStandard"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="不符合标准情况"
          prop="noComplianceStandard"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="主要后果"
          prop="consequences"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否重点管控"
          width="110"
          prop="isFocusControl"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isFocusControl === 0 || scope.row.isFocusControl === '0'"
              >否</span
            >
            <span v-else-if="scope.row.isFocusControl === 1 || scope.row.isFocusControl === '1'"
              >是</span
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          label="伤亡财产损失预测"
          width="180"
          prop="assetsCasualtyPredict"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="LS风险评估方法"
          width="180"
          prop="riskRatingMethodLS"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="LES风险评估方法"
          width="180"
          prop="riskRatingMethodLEC"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="D/R风险值"
          width="180"
          prop="dRiskValue"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="评价级别"
          width="180"
          prop="evaluationLevel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="管控级别"
          width="180"
          prop="controlLevel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="管控层级"
          width="180"
          prop="controlHierarchyText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="责任部门"
          width="180"
          prop="organizationUnitText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="责任人"
          width="180"
          prop="leaderText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="值班电话"
          width="180"
          prop="dutyPhone"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="应急电话"
          width="180"
          prop="emergencyPhone"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <control-equip-form
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    ></control-equip-form>
    <RejectDialog
      v-if="showDialog"
      :taskId="taskId"
      @handleOk="handleOk"
      @cancel="showDialog = false"
    ></RejectDialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { SourcesDangerRiskGradeControlApi } from '@wiz-api/double-prevention-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
// import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import ControlEquipForm from './ControlEquipForm'
import RejectDialog from './RejectDialog'

const sourcesDangerRiskGradeControlApi = new SourcesDangerRiskGradeControlApi()

export default {
  name: 'control-equip-table',
  components: {
    TableOperateButton,
    ControlEquipForm,
    RejectDialog,
    DepartmentSelect,
    // PersonSelect,
  },
  data() {
    return {
      taskId: '',
      pageNo: 1,
      pageSize: 15,
      formProps: {
        title: '新增设备管控',
        editType: 'create',
        visible: true,
      },
      riskLevelList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      value: '',
      formDialog: false,
      showDialog: false,
      formData: {},
      controlStatusList: [],
      evaluateMethodsList: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      position: 0,
      spanArrObj: {},
      spanIndex: 1,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '管控',
            click: () => {
              return this.handleEvent(val, 'control')
            },
            isShow: this.$hasAccess('control') && val.controlStatus === 0,
          },
          {
            text: '驳回',
            click: () => {
              return this.handleEvent(val, 'reject')
            },
            isShow: this.$hasAccess('reject') && val.controlStatus === 0,
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    controlStatusMap() {
      return (val) => {
        return (
          this.controlStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  created() {
    // 1为设备设施 2为作业活动 3为基础管理
    if (
      this.$route.query.id &&
      this.$route.query.tagType &&
      this.$route.query.tagType == 1 &&
      this.$route.query.mode
    ) {
      this.handleEvent(
        {
          palanId: this.$route.query.id,
          planTaskId: this.$route.query.planTaskId,
        },
        this.$route.query.mode === 'approve' ? 'submit' : 'read'
      )
    }
    this.searchList()
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.EvaluateMethods'],
      ['evaluateMethodsList'],
      this
    )
  },
  methods: {
    /**
     * 刷新列表
     */
    async refreshList() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
      this.findList()
    },
    /**
     * 返回
     */
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    handleOk() {
      this.showDialog = false
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'read':
          this.initDialog(row, operation)
          break
        case 'control':
          this.initDialog(row, operation)
          break
        case 'submit':
          this.initDialog(row, operation)
          break
        case 'reject':
          this.taskId = row.id
          this.showDialog = true
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.taskId = row.id
      this.formProps.editType = operation
      this.formData = this.$options.data().formData
      if (row.palanId) {
        const data = {
          palanId: row.palanId,
          taskId: row.planTaskId,
        }
        const [err, res] = await sourcesDangerRiskGradeControlApi.pagedListQuery(data)
        this.formData = this.toList(res.items)[0]
        this.taskId = this.formData.id
      } else {
        this.formData = row
      }
      this.formDialog = true
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.$refs.departmentSelect.userName = ''
      this.searchList()
    },
    async findList() {
      this.spanIndex = 1
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await sourcesDangerRiskGradeControlApi.pagedListQuery(data)

      if (!err) {
        this.tableData = this.toList(res.items)
        this.getSpanArr()
        this.total = res.totalCount
        this.loading = false
      }
    },
    toList(list) {
      return list.reduce((pre, item) => {
        if (item.data && item.data.length) {
          item.data.forEach((i) => {
            i.taskId = item.id
            i.equipmentFacilitySourcesDangerIdentifyId = i.id
            pre.push({
              ...i,
              ...item,
            })
          })
        } else {
          item.taskId = item.id
          pre.push(item)
        }
        return pre
      }, [])
    },
    getSpanArr() {
      this.position = 0
      this.spanArrObj = {}
      const needSpan = ['taskId']
      needSpan.forEach((item) => {
        this.rowspan(item)
      })
    },
    // 获取合并行参数(数组)
    rowspan(prop) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = 0
          item.spanIndex = this.spanIndex
          this.spanIndex += 1
        } else if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
          this.spanArrObj[prop][this.position] += 1
          this.spanArrObj[prop].push(0)
          item.spanIndex = this.spanIndex
        } else {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = index
          item.spanIndex = this.spanIndex
          this.spanIndex += 1
        }
      })
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4, 5, 17, 18, 19, 20, 21, 22].includes(columnIndex)) {
        const _row = this.spanArrObj.taskId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
  },
}
</script>

<style></style>
